// Packages and components
import React, { useState } from 'react';
import { Box } from 'grommet';
import SHDButton from '@ui/Button/SHDButton';
import SHDFooter from '@ui/Footer/SHDFooter';
import SHDHeading from '@ui/Heading/SHDHeading';
import SHDModalContainer from '@ui/ModalContainer/SHDModalContainer';
import SHDText from '@ui/Text/SHDText';

// Types and interfaces
import { DeleteGameModalProps } from './schedule.d';

const DeleteGameModal: React.FC<DeleteGameModalProps> = ({
  onClose,
  onDeleteGame,
  body = '',
}) => {
  // States
  const [isDeleteClicked, setIsDeleteClicked] = useState<boolean>(false);

  return (
    <Box>
      <SHDModalContainer isLast>
        <Box gap="xsmall">
          <SHDHeading level={3} color="black">
            Delete game?
          </SHDHeading>
          {body && (
            <SHDText color="black-alpha-70" style="subhead">
              {body}
            </SHDText>
          )}
        </Box>
      </SHDModalContainer>
      <SHDFooter>
        <SHDModalContainer>
          <Box align="center" gap="small">
            <SHDButton
              warning
              busy={isDeleteClicked}
              label="Delete game"
              onClick={() => {
                setIsDeleteClicked(true);
                onDeleteGame && onDeleteGame();
              }}
            />
            <SHDButton
              secondary
              label="Cancel"
              disabled={isDeleteClicked}
              onClick={() => {
                onClose && onClose();
              }}
            />
          </Box>
        </SHDModalContainer>
      </SHDFooter>
    </Box>
  );
};

export default DeleteGameModal;
